import PowerUp = Trello.PowerUp;
import Board = Trello.PowerUp.Board;
import { Injectable } from '@angular/core';
import { catchError, from, Observable, of } from 'rxjs';
import { Trello } from 'types/trello';

@Injectable({
  providedIn: 'root'
})
export class TrelloService {

  private readonly trello: PowerUp.IFrame;

  constructor() {
    this.trello = (window.TrelloPowerUp as any).iframe();
  }

  public getTrello(): PowerUp.IFrame {
    return this.trello;
  }

  public getBoard(): Observable<Board> {
    return from(this.getTrello().board('id', 'name'));
  }

  public fetchUserToken(): Observable<string> {

    if (!this.trello.isMemberSignedIn()) {
      console.error('Cannot get JWT:', 'user is not signed in');
      return of('');
    }

    return from((this.getTrello() as any).jwt() as Promise<string>)
      .pipe(
        catchError((error: Error) => {
          console.error('Cannot get JWT:', error);
          return of('');
        }),
      );
  }

}
